import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NavbarComponent = _resolveComponent("NavbarComponent")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", {
    id: "app",
    class: _normalizeClass(["container-fluid p-0", _ctx.theme])
  }, [
    _createVNode(_component_NavbarComponent, {
      isAuthenticated: _ctx.isUserAuthenticated,
      isGuest: _ctx.isGuestUser
    }, null, 8, ["isAuthenticated", "isGuest"]),
    _createElementVNode("div", null, [
      _createVNode(_component_router_view)
    ])
  ], 2))
}